import { Data, TransformsList } from 'cio/utils/analytics/transforms';

interface BaseData extends Data {
  builderType?: string;
}

interface CountData extends BaseData {
  folderCount: number;
  assetCount: number;
}

interface FileData extends BaseData {
  fileType: string;
  folderName: string;
  folderId: string;
}

interface ParentFolderData extends BaseData {
  parentFolderName: string;
  parentFolderId: string;
}

interface FolderData extends BaseData {
  folderName: string;
  folderId: string;
}

const generateBaseData = (data: BaseData) => ({
  'Builder Type': data.builderType,
});

const generateCountData = (data: CountData) => ({
  'Folder Count': data.folderCount,
  'Asset Count': data.assetCount,
});

const generateFolderData = (data: FolderData) => ({
  'Folder Name': data.folderName,
  'Folder ID': data.folderId,
});

const generateParentFolderData = (data: ParentFolderData) => ({
  'Parent Folder Name': data.parentFolderName,
  'Parent Folder ID': data.parentFolderId,
});

const Transforms: TransformsList = {
  counts(data: CountData) {
    return {
      ...generateBaseData(data),
      ...generateCountData(data),
    };
  },
  parentFolderData(data: ParentFolderData) {
    return {
      ...generateBaseData(data),
      ...generateParentFolderData(data),
    };
  },
  folderViewedData(data: CountData & FolderData) {
    return {
      ...generateBaseData(data),
      ...generateCountData(data),
      ...generateFolderData(data),
    };
  },
  folderDeleteData(data: FolderData & ParentFolderData) {
    return {
      ...generateBaseData(data),
      ...generateFolderData(data),
      ...generateParentFolderData(data),
    };
  },
  bulkDeleteData(data: ParentFolderData & { count: number }) {
    return {
      ...generateBaseData(data),
      ...generateParentFolderData(data),
      'Checked Count': data.count,
    };
  },
  fileData(data: FileData & FolderData) {
    return {
      ...generateBaseData(data),
      ...generateFolderData(data),
      'Asset ID': data.assetId,
      'File Type': data.fileType,
    };
  },
  fileUploadData(data: FileData & { fileSize: number }) {
    return {
      ...generateBaseData(data),
      ...generateFolderData(data),
      'File Type': data.fileType,
      'File Size': data.fileSize,
    };
  },
};

export default Transforms;
